import { useQuery } from "@tanstack/react-query"
import { useParams } from "react-router-dom"
import { botBuilderKeys, getBot } from "@/entities/bot-builder"
import { useSessionRole } from "@/entities/session"
import { AccessDenied } from "@/shared/ui/access-denied"
import { LoadErrorState } from "@/shared/ui/load-error-state"
import { Skeleton } from "@/shared/ui/skeleton"
import { WorkspaceSection } from "@/widgets/bot-workspace"
import { BotSettings } from "./bot-settings"
import { LoadSwap } from "@/shared/ui/load-swap"

const TITLE = "Бот"

/** Настройки одного бота: статус, включение, сценарий, название, токен. */
export function BotPage() {
	const { botId = "" } = useParams()
	const { isModerator } = useSessionRole()
	const bot = useQuery({
		queryKey: botBuilderKeys.bot(botId),
		queryFn: () => getBot(botId),
		enabled: isModerator && !!botId,
		// Статус приходит от рантайма: держим его свежим, пока страница открыта.
		refetchInterval: 15_000,
	})

	if (!isModerator) return <AccessDenied title={TITLE} />

	return (
		<WorkspaceSection
			title="Общие настройки"
			subtitle="Включение бота, сценарий, название в админке и токен из @BotFather"
		>
			<LoadSwap loading={bot.isLoading} id={bot.data ? "ready" : "error"}>
				{bot.isLoading ? (
					<div className="space-y-3">
						<Skeleton className="h-36 w-full rounded-2xl" />
						<Skeleton className="h-32 w-full rounded-2xl" />
						<Skeleton className="h-32 w-full rounded-2xl" />
					</div>
				) : bot.data ? (
					<BotSettings key={bot.data.id} bot={bot.data} />
				) : (
					<LoadErrorState onRetry={() => bot.refetch()} />
				)}
			</LoadSwap>
		</WorkspaceSection>
	)
}
